<template>
    <!-- 二维码入会进群 -->
    <div class="group-entry-qr-code">
        <div v-if="!loading"
            class="qr-code-wrapper">
            <div class="group">
                <div class="avatar">
                    <img :src="groupAvatar"
                        alt="">
                </div>
                <div class="group-title ellipsis">{{ groupTitle }}</div>
            </div>
            <div class="qr-code">
                <img :src="QRCodeUrl"
                    alt="">
            </div>
            <div class="tips">{{ QRCodeTips }}</div>
        </div>
    </div>
</template>

<script>
import { Dialog, Toast } from 'vant';
import utils from '../../../utils/comUtils.js';

export default {
  data() {
    return {
      groupTitle: '',
      QRCodeTips: '若无法识别可截屏保存后添加',
      QRCodeUrl: '',
      groupAvatar: '',
      params: {
        longitude: '',
        latitude: '',
        coordinateType: '',
        aggregateCodeId: '', // 门店聚合码ID
        source: '', // 端侧来源
        wxLoginCode: '', // 微信登录code
      },
      loading: false,
    };
  },
  watch: {
    loading(newVal) {
      if (newVal) {
        Toast.loading({
          message: '加载中...',
          forbidClick: true,
          duration: 0,
        });
      } else {
        Toast.clear();
      }
    },
  },
  created() {
    const query = this.$route.query;
    if (query) {
      this.params.longitude = query.longitude || '';
      this.params.latitude = query.latitude || '';
      this.params.coordinateType = query.coordinateType || '';
      this.params.aggregateCodeId = query.aggregateCodeId || '';
      this.params.source = query.source || '';
      this.params.wxLoginCode = query.wxLoginCode || '';
    }
    sessionStorage.setItem('loginType', 'wechat');
    this.init();
    this.report();
  },
  methods: {
    init() {
      this.loading = true;
      if (sessionStorage.getItem('userInfo')) {
        this.getPageInfo();
      } else {
        this.userLogin()
          .then((res) => {
            this.getPageInfo();
          })
          .catch((err) => {
            console.error(err);
            Dialog.alert({
              message: err,
            });
            this.loading = false;
          });
      }
    },
    /**
     * 用户登录
     */
    userLogin() {
      return new Promise((resolve, reject) => {
        if (this.params.wxLoginCode) {
          const sc = this.$memberMixSwitch ? 'mobileWxMix' : 'mobileWx';
          const url = this.$memberMixSwitch ? 'quicklogin' : `getsession?code=${this.params.wxLoginCode}`;
          const headers = this.$memberMixSwitch
            ? {
                'content-type': 'application/json',
                accept: 'application/json;charset=UTF-8',
              }
            : { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' };
          const params = this.$memberMixSwitch ? { code: this.params.wxLoginCode } : '';
          this.$api.post({
            noLoading: true,
            sc: sc,
            url: url,
            params: params,
            headers: headers,
            success: (r) => {
              // 针对code过期场景，进行处理
              const isFailed = this.$memberMixSwitch ? r.code !== '666666' : !r.data;
              if (isFailed) {
                reject(r.message || '登录失败，请刷新后重试。');
                return;
              }
              const userUnionid = (r.data && r.data.unionid) || '';
              const userOpenid = (r.data && r.data.openid) || '';
              const accessToken = (r.data && r.data.accessToken) || '';
              const userToken = (r.data && r.data.usertoken) || '';
              const memberCenterId = (r.data && r.data.memberId) || '';
              const member = memberCenterId ? true : false;
              sessionStorage.setItem('userUnionid', userUnionid);
              sessionStorage.setItem('userOpenid', userOpenid);
              sessionStorage.setItem('accessToken', accessToken);
              sessionStorage.setItem('userToken', userToken);
              const userObj = {
                openId: userOpenid,
                unionid: userUnionid,
                accessToken: accessToken,
                userToken: userToken,
                memberCenterId: memberCenterId,
                member: member,
              };
              sessionStorage.setItem('userInfo', JSON.stringify(userObj));
              resolve(userObj);
            },
            failure: () => {
              reject('登录失败，请刷新后重试。');
            },
          });
        } else {
          reject('未登录，请刷新后重试。');
        }
      });
    },
    /**
     * 查询页面信息，如入群二维码，群头像，群名称等
     */
    getPageInfo() {
      this.$api.get({
        sc: 'mobileMarketing',
        url: `activityclubgroupmain/getClubInfo/${this.params.aggregateCodeId}/${this.params.longitude}/${this.params.latitude}/${this.params.coordinateType}`,
        params: {},
        success: (res) => {
          if (res.code === 200) {
            const data = (res.result && res.result.data) || '';
            if (data) {
              this.QRCodeUrl = data.qrcode;
              this.groupTitle = data.room && data.room.nickname;
              this.groupAvatar = data.room && data.room.avatar;
              this.title = data.h5Cfg && data.h5Cfg.title;
              // 设置H5页面title
              document.title = this.title;
            } else {
              Dialog.alert({
                message: `定位的门店社群不存在或已解散，\n请联系导购`,
              });
            }
          } else {
            Dialog.alert({
              message: res.result || '获取页面信息失败',
            });
          }
          this.loading = false;
        },
        failure: (err) => {
          Dialog.alert({
            message: err || '网络不给力，请稍后重试！',
          });
          this.loading = false;
        },
      });
    },
    /**
     * 埋码上报
     */
    report() {
      const params = {
        actionCode: '600040001',
        actionName: ' 一码入会拉起入群二维码',
        content: {
          source: this.params.source,
        },
      };
      utils.handleBatchReport(this, params);
    },
  },
};
</script>

<style scoped lang="scss">
.group-entry-qr-code {
  width: 100vw;
  height: 100vh;
  background-color: #f4f6fe;
  padding: 6.4vw 5.33333vw calc(19.73333vw + env(safe-area-inset-bottom));
  display: flex;
  text-align: center;
  .qr-code-wrapper {
    margin: auto;
    width: 100%;
    background-color: #fff;
    box-shadow: 0 0.8vw 1.6vw 0 rgba(0, 0, 0, 0.05);
    border-radius: 1.6vw;
    padding: 5.33333vw 5.33333vw 8vw;
    .group {
      text-align: left;
      display: flex;
      align-items: center;
      font-size: 4.26667vw;
      font-weight: 700;
      color: rgba(0, 0, 0, 0.85);
      .avatar {
        width: 10.66667vw;
        height: 10.66667vw;
        border-radius: 1.06667vw;
        margin-right: 2.66667vw;
        img {
          width: 10.66667vw;
          height: 10.66667vw;
        }
      }
      .group-title {
        font-weight: bold;
      }
    }
    .qr-code {
      margin-top: 10.66667vw;
      position: relative;
      img {
        width: 57.33333vw;
        height: 57.33333vw;
        vertical-align: middle;
        border-style: none;
      }
    }
    .tips {
      font-size: 3.5vw;
      margin-top: 5.33333vw;
      color: rgba(0, 0, 0, 0.45);
    }
  }
}
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>


// WEBPACK FOOTER //
// src/page/vibrantRubikCube/groupEntryQRCode/GroupEntryQRCode.vue